import React from 'react';
import classNames from 'classnames';
import { SIZES, APPEARANCES, TYPES, HEADING_APPEARANCES, HEADING_TYPES, ALIGN } from './constants';
import Text from '../text';
const Heading = ({
  children,
  type = HEADING_TYPES.heading_1,
  appearance = HEADING_APPEARANCES.default,
  weight = undefined,
  singleLine = false,
  isUppercase = false,
  isHighlighted = false,
  align = ALIGN.left,
}) => {
  const headingClassName = classNames('ws-ui-heading', `ws-ui-heading--${type}`);
  const textAppearance =
    appearance === HEADING_APPEARANCES.default ? APPEARANCES.highEmphasis : appearance;

  return (
    <Text
      type={TYPES.heading}
      size={SIZES.inherit}
      isClipped={singleLine}
      isUppercase={isUppercase}
      isHighlighted={isHighlighted}
      appearance={textAppearance}
      align={align}
      weight={weight}
      className={headingClassName}
    >
      {children}
    </Text>
  );
};

export default Heading;
